export class TaskStatus {
  taskStatusId?: number;
  name?: string;
  description?: string;
}
